module.exports = __webpack_public_path__ + "img/ocean.7d140008.png";